<span id="appVersion" class="hidden-information">{{version}}</span>
<span id="appEnvironment" class="hidden-information">{{environment}}</span>
<router-outlet></router-outlet>
<ng-progress ngProgressHttp/>

